'use strict';

/*
 * General modal controller
*/
SwaggerEditor.controller('ModalCtrl', function ModalCtrl($scope,
  $uibModalInstance) {
  $scope.cancel = $uibModalInstance.close;
  $scope.close = $uibModalInstance.close;
});



//////////////////
// WEBPACK FOOTER
// ./scripts/controllers/modal.js
// module id = 409
// module chunks = 0